import styled, { css, keyframes } from 'styled-components';

const sideBarAnimation = keyframes`
0% {
    width: 0;
  }

  100% {
    width: 465px;
  }`;

export const StyledSidebarWrapper = styled.div`
  z-index: 20;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  background-color: rgb(1 1 1 / 20%);
  justify-content: flex-end;
`;

export const StyledSideBar = styled.div`
  background: ${({ theme }): string => theme.colors!.colorWhite};
  opacity: 1;
  z-index: 100;
  height: 100vh;
  width: 465px;
  font-family: InspireTWDC;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  animation: ${sideBarAnimation} 0.3s ease-out;
  position: relative;
`;

export const StyledHeaderWrapper = styled.div(
  ({ theme }) => css`
    padding: ${theme.spacers!.spacer04} ${theme.spacers!.spacer04} ${theme.spacers!.spacer03} ${theme.spacers!.spacer04};
    border-bottom: 1px solid ${theme.admanColors!.gray.light.bg3[0]};
    position: relative;
  `
);

export const StyledFooterWrapper = styled.div`
  border-top: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg3[0]};
  padding: ${({ theme }): string => theme.spacers!.spacer03};
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }): string => theme.spacers!.spacer02};
`;

export const StyledBodyWrapper = styled.div`
  overflow-y: auto;
  padding: ${({ theme }): string => theme.spacers!.spacer06} ${({ theme }): string => theme.spacers!.spacer04};
  height: 100%;
`;

export const StyledTitleWrapper = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  display: flex;
  color: ${({ theme }): string => theme.admanColors!.gray.light.bg3[3]};
`;

export const StyledCloseCrossIcon = styled.div`
  position: absolute;
  top: ${({ theme }): string => theme.spacers!.spacer04};
  right: ${({ theme }): string => theme.spacers!.spacer04};

  &:hover {
    cursor: pointer;
  }
`;
